import {IconName} from '@vio/atlas/src/components/designSystem/Icon'

import {aiReviewsMessages} from './constants'

export const getCategoryIcon = (category: string): IconName => {
  switch (category) {
    case 'Facilities':
      return 'Dumbell'
    case 'Rooms':
      return 'Room'
    case 'Dining':
      return 'Restaurant'
    case 'Service':
      return 'ServiceBell'
    case 'Cleanliness':
      return 'Clean'
    case 'Location':
      return 'Pin'
    default:
      return 'Information'
  }
}

export const getSplitOverall = (
  overall: string | undefined | null
): string[] => {
  if (!overall) return []
  return overall.split(/\n\n|\\n\\n/) ?? []
}

export const getCategoryTitle = (category: string) => {
  switch (category) {
    case 'Facilities':
      return aiReviewsMessages.facilities
    case 'Rooms':
      return aiReviewsMessages.rooms
    case 'Dining':
      return aiReviewsMessages.dining
    case 'Service':
      return aiReviewsMessages.service
    case 'Cleanliness':
      return aiReviewsMessages.cleanliness
    case 'Location':
      return aiReviewsMessages.location
    default:
      return aiReviewsMessages.facilities
  }
}
